module.exports = __webpack_public_path__ + "static/media/goodday_itemdata.372fcba0.png";